import React, {Component} from 'react'

import {Alert} from 'react-bootstrap'

export default class Message extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: true
    }
  }
  variants = ['danger', 'warning', 'success', 'info']
  render() {
    const {show} = this.state
    const {Type, Mes} = this.props.data
    return (
      show && (
        <Alert
          dismissible
          onClose={() => this.setState({show: false})}
          className='p-1 px-2 my-1'
          variant={this.variants[parseInt(Type)]}>
          {Mes}
        </Alert>
      )
    )
  }
}
